import React from 'react';
import * as d3 from 'd3';
import * as topojson from 'topojson-client';
import '../css/Map.css';


export default class Map extends React.Component {
    constructor(props) {
      super(props)
      
      this.state = {
        usData: null,
      }
      this.anchor = React.createRef();
    }

	componentDidMount() {
        const url = ["https://cdn.jsdelivr.net/npm/us-atlas@2/us/states-10m.json"]

    	Promise.all([
		    fetch(url[0])
	        .then(data => data.json()),
    	])
    	.then((results) => {
    		this.setState({
    			usData: results[0],
    		});
    		this.setMap();
    		this.updateAirports();
    	});
    }

    componentDidUpdate() {
    	console.log(this.props.airports)
    	this.updateAirports()
    }

	setMap() {
		var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 10, top: 10, right: 10, bottom: 10},
	    	width = 960 - margin.left - margin.right,
	      	height = 680 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	const svg = d3.select(this.anchor.current)
      		.append("svg")
      		.style("padding", marginRatio.top + " " + marginRatio.right + " " + marginRatio.bottom + " " + marginRatio.left)
			.attr("preserveAspectRatio", "xMinYMin meet")
			.attr("viewBox", "0 0 " + ( width + margin.left + margin.right  ) + " " + ( height + margin.top + margin.bottom ))
			.attr("id", "svg-content-responsive")
			.attr("class", "graph-svg-placeholder");
    	
        // const { width, height } = this.props;                             

        const path = d3.geoPath();
		const us = this.state.usData;   
        
        var tooltip = d3.select("#mapTooltip")
		    // .append("div")
		    // .style("position", "absolute")
		    // .style("z-index", "999")
		    // // .style("z-index", "10")
		    // .style("visibility", "hidden")
		    // .classed("map-tooltip", true)

		    tooltip.append("rect")
			    .attr("width", 60)
			    .attr("height", 20)
			    .attr("fill", "white")
			    .style("opacity", 0.5);

			tooltip.append("text")
				.attr("x", 30)
				.attr("dy", "1.2em")
				.style("text-anchor", "middle")
				.attr("font-size", "12px")
				.attr("font-weight", "bold");
			
        svg.append("g")
			.attr("class", "feature")
			.selectAll("path")
			.data(topojson.feature(us, us.objects.states).features)
			.enter().append("path")
			.attr("d", path)
			.on("click", (d) => {
				this.handleStateClick(this.props.stateMap[d.properties.name])
			})
			.on("mousemove", d => { 
				// tooltip.text("Total Revenue: ");

				return tooltip.style("top",(d3.event.pageY-100)+"px")
							.style("left",(d3.event.pageX+10)+"px");
			})
			.on("mouseover", function(d){
				// console.log(d);
		      tooltip.text(d.properties.name);
		      return tooltip.style("visibility", "visible");
			})
			.on("mouseout", function() { d3.select(this).style("stroke", "");
      				return tooltip.style("visibility", "hidden"); })
			// .append('title')
			// .text((d) => d.properties.name)

		
		svg.selectAll("text")
		    .data(topojson.feature(us, us.objects.states).features)
		    .enter()
		    .append("svg:text")
		    .text((d) => {
		        return this.props.stateMap[d.properties.name];
		    })
		    .attr("x", function(d){
		        return path.centroid(d)[0];
		    })
		    .attr("y", function(d){
		        return  path.centroid(d)[1];
		    })
		    .attr("text-anchor","middle")
		    .attr('font-size','6pt');

        svg.append("path")
           .attr("class", "state-boundaries")
           .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a !== b; }))
           .attr("class", "mesh")
           .attr("d", path);

        const data = this.props.airports;

    	data.forEach(function (d) {
	        d.LATITUDE = +d.LATITUDE;
	        d.LONGITUDE = +d.LONGITUDE;
	    });

	    // const projection = d3.geoAlbersUsa()
					// 		 .scale(1280)
    	// 					 .translate([480, 300]);

    		svg.append("g")
    				 .attr("id", "mapG")
    				 // .attr("class", "bubble");

   //  	var symbols = g.selectAll("circle")
	  //       		   .data(data, (d) => {return d})

	  //   symbols.enter().append("circle")
			// .attr("class", "enter")
			// .attr("class", "bubble")
			// // .transition(t)
			// .attr("r", 3)
			// .attr("transform", (d) => {
			// 	var location_ = [];
			// 	location_.push(d.LONGITUDE);
			// 	location_.push(d.LATITUDE);
			// 	var proLocation = projection(location_);
			// 	if (!proLocation) proLocation = [867.169335964292, 190.40024748993005];
			// 	return "translate(" + proLocation + ")";
			// })
			// .on("click", (d) => {
			// 	console.log(d);
			// })
   //  		.append("title")
   //  		.text(function(d) { return d.AIRPORT + ', ' + d.STATE })	

	}

	updateAirports() {
		const data = this.props.airports;
    	data.forEach(function (d) {
	        d.LATITUDE = +d.LATITUDE;
	        d.LONGITUDE = +d.LONGITUDE;
	    });

        const projection = d3.geoAlbersUsa()
							    .scale(1280)
    							.translate([480, 300]);

    	const g = d3.select("#mapG");
    	
    	// var maxProperty = Math.max.apply(Math, data.map(function (data) {
	    //     return data.LATITUDE;
	    // }));
    	
        // d3.selectAll(".bubble").remove();

        var t = d3.transition()
      			.duration(400);

        var symbols = g.selectAll('circle')
        			   .data(data, (d) => {return d.AIRPORT})
       	
       	// var tooltip = d3.select("#mapTooltip")
       	// symbols.exit().remove();

       	// EXIT old elements not present in new data.
		symbols.exit()
			.attr("class", "exit")
			.attr("class", "bubble")
			.transition(t)
			.attr("r", 0)
      		.style("fill-opacity", 1e-6)
		  	.remove();

		// UPDATE old elements present in new data.
		symbols.attr("class", "update")
			.attr("class", "bubble")
			// .transition(t)
			.attr("r", 5)
			.attr("transform", function (d) {
				var location_ = [];
				location_.push(d.LONGITUDE);
				location_.push(d.LATITUDE);
				var proLocation = projection(location_);
				if (!proLocation) proLocation = [1000.169335964292, 190.40024748993005];
				return "translate(" + proLocation + ")";
			})
			.on("click", (d) => {
				this.handleAirportClick(d);
			})

    		.append("title")
    		.text(function(d) {return d.AIRPORT + ', ' + d.STATE })

		// ENTER new elements present in new data.
		symbols.enter().append("circle")
			.attr("class", "enter")
			.attr("class", "bubble")
			// .transition(t)
			.attr("r", 5)
			.attr("transform", (d) => {
				var location_ = [];
				location_.push(d.LONGITUDE);
				location_.push(d.LATITUDE);
				var proLocation = projection(location_);
				if (!proLocation) proLocation = [1000.169335964292, 190.40024748993005];
				return "translate(" + proLocation + ")";
			})
			.on("click", (d) => {
				this.handleAirportClick(d)
			})
			.on('mousemove', function() {
				d3.select(this).style("stroke", "black")
			})
			.on('mouseout', function() {
				d3.select(this).style("stroke", "")
			})
			// .on("mousemove", d => { 
			// 	// tooltip.text("Total Revenue: ");
			// 	return tooltip.style("top",(d3.event.pageY-100)+"px")
			// 				.style("left",(d3.event.pageX+10)+"px");
			// })
			// .on("mouseover", d => {
			// 	// console.log(d);
		 //      // d3.select(this).style("stroke", "black");
		 //      tooltip.text(d.AIRPORT + ', ' + d.STATE);
		 //      return tooltip.style("visibility", "visible");
			// })
			// .on("mouseout", function() { d3.select(this).style("stroke", "");
   //    				return tooltip.style("visibility", "hidden"); })
    		.append("title")
    		.text(function(d) { return d.AIRPORT + ', ' + d.STATE })	
	}

    handleAirportClick(airport) {
    	this.props.onAirportClick(airport);
    }

    handleStateClick(state) {
    	this.props.onStateClick(state);
    }
    

    render() {
        return (
        	<React.Fragment>
        	<div ref={this.anchor} />
    		<div id="mapTooltip" className="map-tooltip"/>
        	</React.Fragment>
        );
    }
}